<script setup lang="ts">
import SaveToFolderModal from '@/components/SaveToFolderModal.vue'
import { CONTENT_TYPES } from '@/util/access_visibility'
import type { LibraryImpactOfDisability } from '@/library/library_types'
import { computed, ref } from 'vue'
import { useImpactOfDisabilityStore } from '@/impact-of-disability/impact-of-disability.store'
import { getAnalyticsTracker } from '@/tracking/analytics/plugin.ts'
import { EVENT_NAMES } from '@/tracking/analytics/event_names.ts'
import { useLibraryStore } from '@/library/library.store.ts'

const impactOfDisabilityStore = useImpactOfDisabilityStore()
const libraryStore = useLibraryStore()
const analytics = getAnalyticsTracker()

const props = defineProps({
  contentUuid: {
    type: String,
    required: true
  },
  postCopyNavigate: {
    type: Boolean,
    default: true
  }
})

const statement = computed(() => {
  return impactOfDisabilityStore.savedStatements.find(s => s.uuid === props.contentUuid)
})

const statementCopyUUID = ref('')

const emit = defineEmits<{
  visible: [value: boolean]
  save: [folder: { uuid: string, name: string }]
}>()

function handleStatementCreated(newStatement: LibraryImpactOfDisability) {
  statementCopyUUID.value = newStatement.uuid
  
  const userFolderRole = libraryStore.getUserRoleForFolder(newStatement.student_uuid || '')
  
  analytics.sendEvent(
    EVENT_NAMES.IMPACT_OF_DISABILITY.COPIED_STATEMENT,
    { user_folder_role: userFolderRole }
  )
}

function handleSave(folder: { uuid: string, name: string }) {
  emit('save', folder)
}
</script>

<template>
  <SaveToFolderModal
    :content-type="CONTENT_TYPES.SAVED_IMPACT_OF_DISABILITY"
    content-type-label="Impact of Disability Statement"
    :content-payload="statement"
    custom-header="Copy Impact of Disability Statement to Another Folder"
    :post-save-navigate="postCopyNavigate"
    @update:visible="(val) => emit('visible', val)"
    @statement-created="handleStatementCreated"
    @save="handleSave"
  />
</template>

<style scoped>

</style>
